import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { assetMembershipApi } from 'src/Services/API';
import { trackEvent } from 'src/Services/Matomo';
import { ApiError } from 'src/types/api-error.types';

export const useDeleteMember = () => {
  const queryClient = useQueryClient();
  const assetId = useCurrentAssetId();

  return useMutation<void, AxiosError<ApiError>, string>({
    mutationFn: async (membershipId: string) => {
      if (!assetId) throw new Error('assetId is required for deleting a member');
      await assetMembershipApi.membersControllerDelete(membershipId, assetId);
    },
    onSuccess: (_data, membershipId) => {
      trackEvent('Membership', 'Delete Member', membershipId);
      queryClient.invalidateQueries(['fetch-members', assetId]);
      queryClient.invalidateQueries(['fetch-asset-details', assetId]);
    },
  });
};
